export namespace Sidebar {
  export const key = 'sidebar';

  export interface State {
    isVisible: boolean;
  }
}
